import React, { createContext, useContext, useState, useEffect } from "react";

const translations = {
  es: {
    nav: {
      shop: "Galería",
      artists: "Artistas",
      sell: "Vender",
      login: "Iniciar sesión",
      register: "Registrarse",
      cart: "Carrito",
      logout: "Salir",
      dashboard: "Panel",
    },
    hero: {
      overline: "Marketplace de arte impreso · Edición limitada",
      title: "El arte que vive\nen tus paredes.",
      subtitle: "Obras originales de artistas seleccionados. Impresión fine art sobre papel de calidad museo y enviadas con cuidado a tu casa.",
      cta: "Explorar galería",
      cta2: "Vender tu obra",
    },
    catalog: {
      title: "Galería",
      filter: "Filtrar",
      all: "Todo",
      search: "Buscar obra o artista...",
      empty: "Sin obras todavía.",
    },
    artwork: {
      addToCart: "Añadir al carrito",
      buyNow: "Comprar ahora",
      by: "por",
      description: "Descripción",
      details: "Detalles",
      shipping: "Envío e impresión",
      shippingText: "Impresión fine art bajo demanda sobre papel etching 310gr o lienzo canvas 100% algodón 390gr, con tintas pigmentadas archivables. **Cada obra se entrega con su certificado de autenticidad firmado por el artista.** Envío en 7-10 días.",
    },
    cart: {
      title: "Carrito",
      empty: "Tu carrito está vacío",
      continue: "Seguir explorando",
      subtotal: "Subtotal",
      checkout: "Finalizar pedido",
      remove: "Quitar",
    },
    checkout: {
      title: "Datos de envío",
      name: "Nombre completo",
      email: "Email",
      phone: "Teléfono",
      address: "Dirección",
      city: "Ciudad",
      country: "País",
      place: "Confirmar pedido",
      success: "Pedido confirmado",
      successText: "Hemos recibido tu pedido. Te contactaremos para finalizar el pago e impresión.",
    },
    auth: {
      login: "Iniciar sesión",
      register: "Crear cuenta",
      email: "Email",
      password: "Contraseña",
      name: "Nombre",
      role: "Soy...",
      customer: "Cliente",
      artist: "Artista",
      submit: "Continuar",
      google: "Continuar con Google",
      orDivider: "o",
      noAccount: "¿No tienes cuenta?",
      hasAccount: "¿Ya tienes cuenta?",
    },
    artist: {
      dashboard: "Mi taller",
      overview: "Resumen",
      works: "Mis obras",
      upload: "Subir obra",
      profile: "Mi perfil",
      newWork: "Nueva obra",
      uploadHint: "Define lo que quieres GANAR neto por cada talla. El sistema añade automáticamente el coste de impresión y las comisiones para calcular el PVP final.",
      sizesTitle: "Tallas y precios",
      addSize: "Talla",
      colLabel: "Etiqueta",
      colNet: "Tu neto (€)",
      colCost: "Coste impr.",
      colRetail: "PVP final",
      colNetTotal: "Neto total",
      netEarned: "Mis ingresos netos",
      netSub: "Lo que has ganado tras costes y comisiones",
      totalViews: "Vistas totales",
      topViewed: "Obras más vistas",
      viewsUnit: "vistas",
      breakdownHint: "Coste impresión: {rate}€/m² · mín {min}€. Comisión galería: {gallery}% · Reserva referidor: {ref}%. PVP = (tu neto + coste) / margen disponible.",
      title: "Título",
      description: "Descripción",
      category: "Categoría",
      price: "Precio de venta (€)",
      prodCost: "Coste de producción (€)",
      logCost: "Coste de logística (€)",
      image: "Imagen",
      profit: "Beneficio neto",
      submit: "Enviar para revisión",
      status: "Estado",
      pending: "Pendiente",
      approved: "Aprobada",
      rejected: "Rechazada",
      revenue: "Ingresos",
      units: "Unidades vendidas",
      costs: "Costes",
    },
    admin: {
      dashboard: "Administración",
      overview: "Resumen",
      approvals: "Aprobaciones",
      orders: "Pedidos",
      users: "Usuarios",
      settings: "Ajustes",
      artworks: "Obras",
      revenue: "Ingresos plataforma",
      galleryEarnings: "Ingresos galería",
      referrerPayouts: "Pagos a referidores",
      approve: "Aprobar",
      reject: "Rechazar",
      orderStatus: "Estado del pedido",
      printing: "Imprimiendo",
      shipped: "Enviado",
      delivered: "Entregado",
      cancelled: "Cancelado",
    },
    adminSettings: {
      title: "Tarifas y comisiones",
      subtitle: "Estos valores se aplican al cálculo de precios de todas las obras nuevas y en visualización pública.",
      printRate: "Tarifa impresión (€/m²)",
      printRateHint: "Incluye papel/lienzo + tintas + envío.",
      printMin: "Mínimo impresión (€)",
      galleryPct: "Comisión galería (%)",
      referrerPct: "Comisión referidor (%)",
      cookieDays: "Cookie referidor (días)",
      save: "Guardar tarifas",
      saved: "Tarifas actualizadas",
      preview: "Vista previa",
      previewHint: "Ejemplo: obra original de 80×100cm con un neto deseado de 180€.",
      exNet: "Neto artista",
      exCost: "Coste impresión",
      exGallery: "Comisión galería",
      exReferrer: "Reserva referidor",
      exRetail: "PVP final",
    },
    adminUsers: {
      title: "Usuarios",
      subtitle: "Promueve clientes a artistas o referidores asignando su rol.",
      search: "Buscar por nombre o email...",
      name: "Nombre",
      role: "Rol",
      created: "Alta",
    },
    referrer: {
      title: "Panel referidor",
      subtitle: "Genera tráfico hacia Nüart gallery y gana comisión por cada venta atribuida a tu enlace.",
      overview: "Resumen",
      yourLink: "Tu enlace de referido",
      copy: "Copiar",
      copied: "Copiado",
      linkHint: "Comparte este enlace en tus redes, web o con tus clientes. Toda venta originada en él (en los próximos 30 días desde el clic) te genera una comisión del 10%.",
      clicks: "Clics totales",
      salesAttributed: "Ventas atribuidas",
      salesVolume: "Volumen ventas",
      commission: "Comisión",
      recentOrders: "Pedidos recientes atribuidos",
      yourCommission: "Tu comisión",
    },
    profile: {
      title: "Mi perfil",
      subtitle: "Esta información será visible públicamente en tu página de artista.",
      name: "Nombre",
      bio: "Biografía / Currículo",
      bioPlaceholder: "Cuéntale al mundo quién eres como artista, tu trayectoria, exposiciones, técnica favorita...",
      save: "Guardar cambios",
      saved: "Perfil actualizado",
      changePicture: "Cambiar foto",
      viewPublic: "Ver mi perfil público",
      social: "Redes sociales y enlaces",
    },
    artistPublic: {
      overline: "Artista d-Pod Gallery",
      archive: "Obras del artista",
      works: "obras",
      work: "obra",
      notFound: "Artista no encontrado",
    },
  },
  en: {
    nav: {
      shop: "Gallery",
      artists: "Artists",
      sell: "Sell",
      login: "Sign in",
      register: "Sign up",
      cart: "Cart",
      logout: "Sign out",
      dashboard: "Dashboard",
    },
    hero: {
      overline: "Printed art marketplace · Limited edition",
      title: "The art that lives\non your walls.",
      subtitle: "Original works from curated artists. Museum-grade fine art printing, shipped with care to your home.",
      cta: "Browse gallery",
      cta2: "Sell your work",
    },
    catalog: {
      title: "Gallery",
      filter: "Filter",
      all: "All",
      search: "Search artwork or artist...",
      empty: "No artworks yet.",
    },
    artwork: {
      addToCart: "Add to cart",
      buyNow: "Buy now",
      by: "by",
      description: "Description",
      details: "Details",
      shipping: "Print & shipping",
      shippingText: "Fine art print-on-demand on 310gsm etching paper or 390gsm 100% cotton canvas with archival pigment inks. **Each piece is delivered with a certificate of authenticity signed by the artist.** Delivered in 7-10 days.",
    },
    cart: {
      title: "Cart",
      empty: "Your cart is empty",
      continue: "Keep browsing",
      subtotal: "Subtotal",
      checkout: "Place order",
      remove: "Remove",
    },
    checkout: {
      title: "Shipping details",
      name: "Full name",
      email: "Email",
      phone: "Phone",
      address: "Address",
      city: "City",
      country: "Country",
      place: "Confirm order",
      success: "Order confirmed",
      successText: "We've received your order. We'll contact you to finalize payment and printing.",
    },
    auth: {
      login: "Sign in",
      register: "Create account",
      email: "Email",
      password: "Password",
      name: "Name",
      role: "I am a...",
      customer: "Customer",
      artist: "Artist",
      submit: "Continue",
      google: "Continue with Google",
      orDivider: "or",
      noAccount: "No account yet?",
      hasAccount: "Already have an account?",
    },
    artist: {
      dashboard: "My studio",
      overview: "Overview",
      works: "My works",
      upload: "Upload",
      profile: "My profile",
      newWork: "New work",
      uploadHint: "Set the NET amount you want to earn for each size. The system automatically adds printing cost and commissions to calculate the final retail price.",
      sizesTitle: "Sizes & pricing",
      addSize: "Size",
      colLabel: "Label",
      colNet: "Your net (€)",
      colCost: "Print cost",
      colRetail: "Retail",
      colNetTotal: "Total net",
      netEarned: "My net earnings",
      netSub: "What you've earned after costs and commissions",
      totalViews: "Total views",
      topViewed: "Most viewed works",
      viewsUnit: "views",
      breakdownHint: "Print cost: {rate}€/m² · min {min}€. Gallery commission: {gallery}% · Referrer reserve: {ref}%. Retail = (your net + cost) / available margin.",
      title: "Title",
      description: "Description",
      category: "Category",
      price: "Sale price (€)",
      prodCost: "Production cost (€)",
      logCost: "Logistics cost (€)",
      image: "Image",
      profit: "Net profit",
      submit: "Submit for review",
      status: "Status",
      pending: "Pending",
      approved: "Approved",
      rejected: "Rejected",
      revenue: "Revenue",
      units: "Units sold",
      costs: "Costs",
    },
    admin: {
      dashboard: "Admin",
      overview: "Overview",
      approvals: "Approvals",
      orders: "Orders",
      users: "Users",
      settings: "Settings",
      artworks: "Artworks",
      revenue: "Platform revenue",
      galleryEarnings: "Gallery earnings",
      referrerPayouts: "Referrer payouts",
      approve: "Approve",
      reject: "Reject",
      orderStatus: "Order status",
      printing: "Printing",
      shipped: "Shipped",
      delivered: "Delivered",
      cancelled: "Cancelled",
    },
    adminSettings: {
      title: "Rates & commissions",
      subtitle: "These values apply to all new artwork pricing and public display.",
      printRate: "Print rate (€/m²)",
      printRateHint: "Includes paper/canvas + inks + shipping.",
      printMin: "Print minimum (€)",
      galleryPct: "Gallery commission (%)",
      referrerPct: "Referrer commission (%)",
      cookieDays: "Referrer cookie (days)",
      save: "Save settings",
      saved: "Settings saved",
      preview: "Preview",
      previewHint: "Example: 80×100cm original with a target net of €180.",
      exNet: "Artist net",
      exCost: "Print cost",
      exGallery: "Gallery commission",
      exReferrer: "Referrer reserve",
      exRetail: "Retail price",
    },
    adminUsers: {
      title: "Users",
      subtitle: "Promote customers to artists or referrers by changing their role.",
      search: "Search by name or email...",
      name: "Name",
      role: "Role",
      created: "Joined",
    },
    referrer: {
      title: "Referrer panel",
      subtitle: "Drive traffic to Nüart gallery and earn commission on every sale attributed to your link.",
      overview: "Overview",
      yourLink: "Your referral link",
      copy: "Copy",
      copied: "Copied",
      linkHint: "Share this link on your socials, site or with your clients. Any sale originated from it (within 30 days of the click) earns you a 10% commission.",
      clicks: "Total clicks",
      salesAttributed: "Attributed sales",
      salesVolume: "Sales volume",
      commission: "Commission",
      recentOrders: "Recent attributed orders",
      yourCommission: "Your commission",
    },
    profile: {
      title: "My profile",
      subtitle: "This information will be visible on your public artist page.",
      name: "Name",
      bio: "Bio / CV",
      bioPlaceholder: "Tell the world who you are as an artist, your career, exhibitions, favourite technique...",
      save: "Save changes",
      saved: "Profile updated",
      changePicture: "Change picture",
      viewPublic: "View public profile",
      social: "Social media & links",
    },
    artistPublic: {
      overline: "d-Pod Gallery Artist",
      archive: "Artist's works",
      works: "works",
      work: "work",
      notFound: "Artist not found",
    },
  },
};

const I18nContext = createContext(null);

export const I18nProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("lang") || "es");

  useEffect(() => {
    localStorage.setItem("lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = translations[lang];
  const toggle = () => setLang(lang === "es" ? "en" : "es");

  return <I18nContext.Provider value={{ lang, t, toggle, setLang }}>{children}</I18nContext.Provider>;
};

export const useI18n = () => useContext(I18nContext);
